var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("base-layout", {
    attrs: { "layout-classes": _vm.layoutClasses },
    scopedSlots: _vm._u(
      [
        _vm.isMobile && _vm.mobilePageTitle
          ? {
              key: "header",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass:
                        "mobile-history-header d-flex justify-content-between align-items-center",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "cursor-pointer",
                          staticStyle: { height: "fit-content", width: "30px" },
                          on: {
                            click: function ($event) {
                              return _vm.$router.go(-1)
                            },
                          },
                        },
                        [
                          _c("img", {
                            staticStyle: { height: "18px" },
                            attrs: {
                              src: `${_vm.$s3}/img/common/history/backArrow.svg?${_vm.$ver}`,
                            },
                          }),
                        ]
                      ),
                      _c("div", { staticClass: "mobile-header-title" }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t(_vm.mobilePageTitle)) +
                            "\n      "
                        ),
                      ]),
                      _c("div", {
                        staticStyle: { height: "fit-content", width: "30px" },
                      }),
                    ]
                  ),
                ]
              },
              proxy: true,
            }
          : null,
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }